module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "modal .collapse.show",
    attrs: {
      "tabindex": "-1",
      "role": "dialog",
      "aria-labelledby": "deleteModalLabel",
      "aria-hidden": "true"
    }
  }, [_c('div', {
    staticClass: "modal-dialog modal-dialog-centered",
    attrs: {
      "role": "document"
    }
  }, [_c('div', {
    staticClass: "modal-content"
  }, [_c('div', {
    staticClass: "delete-modal-header"
  }, [_c('h3', {
    staticClass: "modal-title"
  }, [_vm._v("Agente de registro de um PSBIO externo")]), _vm._v(" "), _c('button', {
    staticClass: "close",
    attrs: {
      "type": "button",
      "data-dismiss": "modal",
      "aria-label": "Close"
    },
    on: {
      "click": _vm.hide
    }
  }, [_c('span', {
    attrs: {
      "aria-hidden": "true"
    }
  }, [_vm._v("×")])])]), _vm._v(" "), _c('div', {
    staticClass: "delete-body"
  }, [_c('div', {
    staticClass: "body-title"
  }, [_vm._v("adicionar agente de registro externo")]), _vm._v(" "), _c('div', {
    staticClass: "delete-row"
  }, [_c('div', {
    staticClass: "form-group"
  }, [_c('label', {
    staticClass: "delete-label"
  }, [_vm._v("CPF do novo agente")]), _vm._v(" "), _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.cpf),
      expression: "cpf"
    }],
    staticClass: "form-control",
    attrs: {
      "type": "text",
      "id": "cpf",
      "readonly": "",
      "required": ""
    },
    domProps: {
      "value": (_vm.cpf)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.cpf = $event.target.value
      }
    }
  })])]), _vm._v(" "), (_vm.loading) ? _c('div', {
    staticClass: "spinner-border text-primary",
    attrs: {
      "role": "status"
    }
  }, [_c('span', {
    staticClass: "visually-hidden"
  }, [_vm._v("Loading...")])]) : _vm._e(), _vm._v(" "), _c('samp', {
    staticClass: "external-response"
  }, [_vm._v(_vm._s(_vm.apiResponse))])]), _vm._v(" "), _c('div', {
    staticClass: "modal-footer"
  }, [_c('button', {
    staticClass: "btn btn-secondary",
    attrs: {
      "type": "button",
      "data-dismiss": "modal"
    },
    on: {
      "click": _vm.hide
    }
  }, [_vm._v("Cancelar")]), _vm._v(" "), (_vm.enrollBtn) ? _c('button', {
    staticClass: "btn btn-primary",
    attrs: {
      "type": "button"
    },
    on: {
      "click": _vm.register
    }
  }, [_vm._v("\n          Registrar\n        ")]) : _vm._e()])])])])
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-6916672f"}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/interfaces/components/ExternalAgentModal.vue
// module id = 260
// module chunks = 0